export default __webpack_public_path__ + "static/media/ResultHistory.93a07185.svg";